/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/* eslint-disable class-methods-use-this */
import { Inject, Injectable } from '@angular/core';
import { WINDOW } from 'src/common/services/window.service';
import { AppConfigService } from '../../common/services/app-config/app-config.service';

/**
 * A service for recording TelemetryEvents.
 */
@Injectable({
  providedIn: 'root',
})
export class RecordEventService {
  constructor(private appConfig: AppConfigService, @Inject(WINDOW) private window: Window) { }

  /**
   * The arguements map to Google Analytics Event data, as referenced here:
   * https://developers.google.com/analytics/devguides/collection/ga4/reference/events
   * @param action The event action of the event.
   * @param category The category of the event.
   * @param label The label of the event.
   * @param value The monetary value of the event.
   * @returns
   */
  public recordEvent(
    action: string,
    category: string = null,
    label: string = null,
    value: Number = null,
  ) {
    // Return early if telemetry is disabled, or global gtag method is unavailable.
    if (!this.appConfig.telemetry.enabled || !this.window.gtag) return;
    this.window.gtag('event', action, {
      category,
      label,
      value,
    });
  }
}
